import {TableState} from "../../common/models/TableState";
import {AxiosClientFactory} from "../../common/helpers/AxiosClientFactory";
import {MarketingListSummary} from "../model/MarketingListSummary";

export const getMarketingLists = (params: Partial<TableState>): Promise<MarketingListSummary[]> => {
    return AxiosClientFactory
        .getInstance()
        .get<MarketingListSummary[]>('/api/marketingLists', { params })
        .then((result) => result.data);
};